import { formatModerationTimestamp } from "./moderationReports";
import {
  countPriorSuspensions,
  suspensionHistorySummary,
  type AdminSuspensionHistoryEntry,
} from "./moderationSuspensions";

export function ModerationSuspensionHistory({
  entries,
}: {
  entries: AdminSuspensionHistoryEntry[];
}) {
  if (entries.length === 0) return null;

  const priorCount = countPriorSuspensions(entries);
  const summary = suspensionHistorySummary(entries);

  return (
    <div className="moderation-suspension-history">
      <h3>
        Suspension history
        {priorCount > 0 && <span className="moderation-suspension-history-count">{priorCount}</span>}
      </h3>
      {summary && <p className="moderation-suspension-history-summary">{summary}</p>}
      <div className="moderation-suspension-history-list">
        {entries.map((entry) => (
          <article
            className={`moderation-suspension-item moderation-suspension-item--${entry.kind}`}
            key={entry.id}
          >
            <div className="moderation-suspension-item-head">
              <span className={`moderation-suspension-kind moderation-suspension-kind--${entry.kind}`}>
                {entry.label}
              </span>
              <time dateTime={entry.createdAt}>{formatModerationTimestamp(entry.createdAt)}</time>
            </div>
            {entry.actorEmail && (
              <p className="moderation-suspension-meta">By {entry.actorEmail}</p>
            )}
            {entry.note && <p className="moderation-suspension-note">{entry.note}</p>}
          </article>
        ))}
      </div>
    </div>
  );
}
